import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import SectionFaq from '@/pages/home/components/SectionFaq';
import SectionTopics from '@/pages/home/components/SectionTopics';
import SectionContact from '@/pages/home/components/SectionContact';
import SectionComments from '@/pages/home/components/SectionComments';
import SectionAbout from '@/pages/home/components/SectionAbout';
import SectionRanking from '@/pages/home/components/SectionRanking';
import SectionMedia from '@/pages/home/components/SectionMedia';
import SectionCards from '@/pages/home/components/SectionCards';
import SectionApp from '@/pages/home/components/SectionApp';
import SectionUpdates from '@/pages/home/components/SectionUpdates';
import SectionIndex from '@/pages/home/components/SectionIndex';
import SectionCarousel from '@/pages/home/components/SectionCarousel';
import SectionFeatures from '@/pages/home/components/SectionFeatures';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <SectionFaq />
        <SectionTopics />
        <SectionContact />
        <SectionComments />
        <SectionAbout />
        <SectionRanking />
        <SectionMedia />
        <SectionCards />
        <SectionApp />
        <SectionUpdates />
        <SectionIndex />
        <SectionCarousel />
        <SectionFeatures />
      </main>
      <Footer />
    </>
  );
}